import typesRestService from '../services/types/TypesRestService'

const state = {
  packagingTypes: [],
  grainTypes: [],
  qualityTypes: [],
  agrochemicalTypes: [],
  agroApplicationTypes: [],
  measurmentUnits: [{
    id: 1,
    name: 'Kilogramo',
    symbol: 'kg'
  },
  {
    id: 2,
    name: 'Litro',
    symbol: 'l'
  }]
}

const getters = {
  getPackagingTypes: state => state.packagingTypes,
  getGrainTypes: state => state.grainTypes,
  getQualityTypes: state => state.qualityTypes,
  getAgrochemicalTypes: state => state.agrochemicalTypes,
  getMeasurmentUnits: state => state.measurmentUnits,
  getAgrochemicalApplicationTypes: state => state.agroApplicationTypes
}

const actions = {
  async getPackagingTypes (context) {
    try {
      let data = await typesRestService.getPackagingTypes()
      context.commit('setPackagingTypes', data)
    } catch (e) {
      console.log('Error fetching Packaging Types')
    }
  },
  async getGrainTypes (context) {
    try {
      let data = await typesRestService.getGrainTypes()
      context.commit('setGrainTypes', data)
    } catch (e) {
      console.log('Error fetching Grain Types')
    }
  },
  async getQualityTypes (context) {
    try {
      let data = await typesRestService.getQualityTypes()
      context.commit('setQualityTypes', data)
    } catch (e) {
      console.log('Error fetching Quality Types')
    }
  },
  async getAgrochemicalTypes (context) {
    try {
      let data = await typesRestService.getAgrochemicalTypes()
      context.commit('setAgrochemicalTypes', data)
    } catch (e) {
      console.log('Error fetching Agrochemical Types')
    }
  },
  async getAgrochemicalApplicationTypes (context) {
    try {
      let data = await typesRestService.getAgrochemicalApplicationTypes()
      context.commit('setAgrochemicalApplicationTypes', data)
    } catch (e) {
      console.log('Error fetching Agrochemical Application Types')
    }
  }
}

const mutations = {
  setPackagingTypes (state, data) {
    state.packagingTypes = data
  },
  setGrainTypes (state, data) {
    state.grainTypes = data
  },
  setQualityTypes (state, data) {
    state.qualityTypes = data
  },
  setAgrochemicalTypes (state, data) {
    state.agrochemicalTypes = data
  },
  setAgrochemicalApplicationTypes (state, data) {
    state.agroApplicationTypes = data
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
